import { type SearchModes } from '@/domainLogic/index.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { TranslationFunction } from '@/app/components/translations/Translation';
import type { SearchInfoDetailData } from '@/app/search/types.ts';
import { SortValues } from '@/app/common/memsearch/types.ts';
import { type ControlProps, ControlType } from '../../../../Form';
import FilterContainer from '../../FilterContainer';
import { getSortOptions } from './getSortOptions';
import type { Localization } from '../../../../../common/Localization';

const getSortControl = ({
  searchMode,
  searchParams,
  searchInfoDetailData,
  isListView,
  imageBasePath,
  localization,
  isMobile,
  t,
}: {
  searchMode: SearchModes;
  searchParams: SearchParams;
  searchInfoDetailData: SearchInfoDetailData;
  isListView: boolean;
  imageBasePath: string;
  basic?: boolean;
  localization: Localization;
  isMobile: boolean;
  t: TranslationFunction;
}): ControlProps => ({
  control: ControlType.CONTAINER,
  name: FilterContainer.SortContainer,
  controls: [
    {
      control: ControlType.RADIO,
      name: URLParameters.SORT,
      className: 'openx-ui-sort-modal',
      options: getSortOptions({
        searchMode,
        searchInfoDetailData,
        isListView,
        imageBasePath,
        localization,
        isMobile,
        t,
      }),
      value: searchParams[URLParameters.SORT] || SortValues.Recommended,
      default: SortValues.Recommended,
    },
  ],
});

export default getSortControl;
